import React from 'react';
import styled from 'styled-components';
import { Loading, Pagination } from '../../../../components/elements';
import CompanyRow from './CompanyRow';

const Wrap = styled.div`
  background: #fff;
  border: 1px solid #E8DDD6;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(22, 17, 13, 0.06);
  overflow: hidden;
`;

const Toolbar = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid #E8DDD6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

const ToolbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const ToolbarInfo = styled.span`
  font-size: 12.5px;
  color: #7A6A60;
`;

const ToolbarRight = styled.div`
  display: flex;
  gap: 7px;
`;

const SortBtn = styled.button`
  cursor: pointer;
  border: 1px solid #E8DDD6;
  outline: none;
  border-radius: 7px;
  transition: all 0.14s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 10px;
  background: ${({ active }) => (active ? '#FEF3EC' : '#F2EDE8')};
  color: ${({ active }) => (active ? '#F36E21' : '#7A6A60')};
  border-color: ${({ active }) => (active ? '#F36E21' : '#E8DDD6')};
  &:hover {
    opacity: 0.85;
  }
`;

const ColHeader = styled.div`
  display: grid;
  grid-template-columns: 30px 2fr 1.2fr 1.2fr 70px 1.8fr 110px 100px 90px;
  padding: 9px 16px;
  background: #FAF8F6;
  border-bottom: 1px solid #E8DDD6;
`;

const ColLabel = styled.span`
  font-size: 9.5px;
  font-weight: 700;
  color: #7A6A60;
  text-transform: uppercase;
  letter-spacing: 0.9px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px 16px;
  background: #FAF8F6;
  border-top: 1px solid #E8DDD6;
`;

const FooterText = styled.span`
  font-size: 12px;
  color: #7A6A60;
`;

const EmptyMsg = styled.div`
  padding: 40px;
  text-align: center;
  font-size: 13px;
  color: #B8AAA2;
`;

const LoadingWrap = styled.div`
  padding: 32px;
  display: flex;
  justify-content: center;
`;

const SORT_OPTIONS = [
  // { label: 'Name ↕', asc: 'NAME_ASC', desc: 'NAME_DESC' },
  // { label: 'Places ↕', asc: 'COUNTS_ASC', desc: 'COUNTS_DESC' },
  { label: 'Updated ↕', asc: 'UPDATED_ASC', desc: 'UPDATED_DESC' },
];

const CompanyTable = ({
  companies,
  totalSize,
  totalPages,
  loading,
  error,
  listSize,
  pageFrom,
  setPageFrom,
  currentPage,
  setCurrentPage,
  sort,
  setSort,
  onRowClick,
  onEdit,
}) => {
  const start = pageFrom + 1;
  const end = Math.min(pageFrom + listSize, totalSize);

  const handleSort = (asc, desc) => {
    setSort(sort === asc ? desc : asc);
  };

  return (
    <Wrap>
      <Toolbar>
        <ToolbarLeft>
          <ToolbarInfo>
            {totalSize.toLocaleString()} companies
          </ToolbarInfo>
        </ToolbarLeft>
        <ToolbarRight>
          {SORT_OPTIONS.map(({ label, asc, desc }) => (
            <SortBtn
              key={label}
              active={sort === asc || sort === desc}
              onClick={() => handleSort(asc, desc)}
            >
              {label}
            </SortBtn>
          ))}
        </ToolbarRight>
      </Toolbar>

      <ColHeader>
        <span />
        <ColLabel>Company</ColLabel>
        <ColLabel>ABN</ColLabel>
        <ColLabel>Primary Contact</ColLabel>
        <ColLabel>Places</ColLabel>
        <ColLabel>Place Names</ColLabel>
        <ColLabel>State</ColLabel>
        <ColLabel>Bank</ColLabel>
        <ColLabel>Actions</ColLabel>
      </ColHeader>

      {loading ? (
        <LoadingWrap><Loading /></LoadingWrap>
      ) : error ? (
        <EmptyMsg>Error loading companies. Please try again.</EmptyMsg>
      ) : companies.length === 0 ? (
        <EmptyMsg>No companies found matching the selected filters.</EmptyMsg>
      ) : (
        companies.map(company => (
          <CompanyRow
            key={company.company_id}
            company={company}
            onRowClick={onRowClick}
            onEdit={onEdit}
          />
        ))
      )}

      {totalSize > 0 && (
        <Footer>
          <FooterText>
            Showing {start.toLocaleString()}–{end.toLocaleString()} of {totalSize.toLocaleString()}
          </FooterText>
          <Pagination
            pageFrom={pageFrom}
            pageCount={totalPages}
            listSize={listSize}
            totalElements={totalSize}
            currentPage={currentPage}
            handlePageClick={value => {
              setPageFrom(value.selected * listSize);
              setCurrentPage(value.selected);
            }}
          />
        </Footer>
      )}
    </Wrap>
  );
};

export default CompanyTable;
